module.exports = __webpack_public_path__ + "r-v3/img/pen_blue.4db858f3.svg";